import { Tab } from "@headlessui/react";
import CarCard from "components/CarCard/CarCard";
import React, { useEffect, useState } from "react";
import CommonLayout from "./CommonLayout";
import { useServices } from "../../hooks/collections/useServices";
import { useNavigate } from "react-router-dom";
import { useUserSessionStore } from "../../stores/UserSession.store";
import { IService } from "../../@core/interfaces/IService";
import { NotFound } from "components/NotFound/NotFound";

const AccountSavedServices = () => {
  const user = useUserSessionStore((state) => state.user);
  const { getServices } = useServices(false);
  const [services, setServices] = useState([]);
  const navigate = useNavigate();

  const redirectToService = (service: IService) => {
    navigate(`/service-detail/${service.id}`);
  };

  useEffect(() => {
    getServices(user.favorites || []).then((services) => setServices(services));
  }, [user?.favorites]);

  const renderSectionServicesList = () => {
    return (
      <div className="space-y-6 sm:space-y-8">
        <div className={'flex justify-between items-center'}>
          <h2 className="text-3xl font-semibold">Saved Services</h2>
        </div>
        <div>
          {services.length > 0 ? (
            <Tab.Group>
              <Tab.Panels>
                <Tab.Panel className="mt-8">
                  <div className="grid grid-cols-1 gap-6 md:gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                    {services?.map((service) => (
                      <div
                        key={service.id}
                        onClick={() => redirectToService(service)}
                      >
                        <CarCard data={service}/>
                      </div>
                    ))}
                  </div>
                </Tab.Panel>
              </Tab.Panels>
            </Tab.Group>
          ) : <NotFound description={"There are no saved services"}/>}
        </div>
      </div>
    );
  };

  if (!user) return <></>;

  return (
    <div>
      <CommonLayout>{renderSectionServicesList()}</CommonLayout>
    </div>
  );
};

export default AccountSavedServices;
